import { atom } from "jotai";

export const elementAtom = atom<string>("");
